import Typography from "antd/lib/typography";
import clsx from "clsx";

import { SkillLevelValidationStatus } from "@sol/sdk";

import SkillLevelTag from "./SkillLevelTag";

type Props = {
    level: number;
    levelsCount: number;
    validLevels: number;
    className?: string;
};

const SkillLevelsMetrics = ({ level, levelsCount, validLevels, className }: Props) => {
    return (
        <p
            className={clsx(
                "flex items-center gap-ant-sm rounded-ant-lg border-ant border-ant-secondary bg-ant-container p-ant pr-ant-sm",
                className,
            )}
        >
            <Typography.Text className="shrink-0">
                <span className="text-ant-lg font-ant-strong">{validLevels}</span> / {levelsCount}
            </Typography.Text>
            <SkillLevelTag level={level} status={SkillLevelValidationStatus.VALIDATED} hideIcon className="w-full" />
        </p>
    );
};

export default SkillLevelsMetrics;
